import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import  { Arrow } from '../components/buttons/record';
import { PreFooter } from '../components/page';
import '../styles/pages/start.scss';
import { tspan } from '../utils/i18n';
import {HexagonSmall} from "../components/hexagon";
import {faMicrophone} from "@fortawesome/pro-solid-svg-icons";
import SendVox from '../components/buttons/send';
import { faMicrophone as solidMic } from "@fortawesome/pro-solid-svg-icons";
import {ColoredFooter} from "./mic-check";
import { hostedRecord, pluginRecord } from '../utils/alt-tags';

const queryString = require('query-string');

export const TitleText = styled.span`
    
    font-style: normal;
    font-family: Titillium Web;
    font-weight:${props => props.subTitle ? 'normal' : 'bold'} ;
    font-size: ${props => props.subTitle ? '15px' : '16px'} ;
    line-height: 24px;
    height: 24px;
    color:'#27364E';
    >:nth-child(2) {
        /* margin-top: 2px; */
        display: inline-flex;
    }
    
`;
const ContactName = styled.div`
  p {
    margin: 1px 0px 5px 0px;
  }
`;

export const StartContainer = styled.div`
    .title {
            ${({ settings }) => {
                return settings.mode === 'sample' ? css`
                    max-width: 50%;
                    text-align: left;
                    color: #f39609;

                    line-height: 1.6rem !important;
                    font-size: 2rem !important;
                    font-weight: 700 !important;

                    @media (min-width:420px) {
                        line-height: 2rem !important;
                        font-size: 3rem !important;
                        font-weight: 700 !important;
                    }
                ` : css`
                    font-size: 1.2rem !important;
                    line-height: 1.5rem !important;
                    font-weight: normal !important;
                `
            }
            }

            padding: 1rem 2rem;
            padding-top: 0.9rem;
            ${props => props.pluginMode && css`
                padding-bottom: 0.5rem;
            `}

            img {
                height: 1.25rem;
            }
        }

        .sub-title {
            ${({ settings }) => css`
            margin-top: 0.5625rem;
                ${settings.mode === 'sample' ? css`
                    max-width: 50%;

                    ${breakpoint('xs', 'sm')`
                    font-size: 1rem !important;
                    line-height: 1.5rem !important;
                    font-weight: normal !important;
                    `}
                    ${breakpoint('sm')`
                    font-size: 1.2rem !important;
                    line-height: 1.5rem !important;
                    font-weight: normal !important;
                    `}

                    display: flex;
                    flex-direction: column;

                    >:first-child {
                        text-align: center;
                        font-wieght: 900;
                        color: #ccc;
                        width: 100%;

                        ~ * {
                            text-align: left;  
                            font-weight: 100 !important;
                            ::first-letter {
                                ${breakpoint('xs', 'sm')`
                                font-size: 2rem !important;
                                font-weight: 500 !important;
                                `}
                                ${breakpoint('sm')`
                                font-size: 2.25rem !important;
                                font-weight: 500 !important;
                                `}
                            }
                        }
                    }

                    >:last-child {
                        font-weight: 500 !important;
                        text-align: center;
                        ::first-letter {
                            font-size: inherit !important;
                        }
                    }
                ` : `
                    font-size: 0.8rem;
                    line-height: 1rem;
                    font-weight: lighter;
                `}
            `}

            img {
                height: 1rem;
            }
        }
`;

export const MicImage = styled.div`
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    div {
        height: 27px;
        width: 28px;
        padding: 0 !important;
        svg:nth-child(1) {
            height: 12px;
            width: 12px;
        }
        svg:nth-child(2) {
            height: 2rem;
            width: 2rem;
        }
    }
`;
const SubFooter = styled.p`
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    color: #858C9A;
    margin-bottom: 0.375rem;
`;
export default class Start extends Component {

    static propTypes = {
        onSwitch: PropTypes.func.isRequired
    }

    state = {
      fName: '',
      email: '',
      sourceType: '',
      micGranted: false,
      processing: false,
    }

    async componentDidMount() {

        const {query} = queryString.parseUrl(window.location.href);
      if (query && query.reply === 'reply'){
        this.setState({
          sourceType: query.reply,
          email: query.userEmail,
          fName: query.userName,
        });
        const header = document.getElementsByClassName('plugin-content');
        if (header){
          header[0].children[0].remove();
          header[0].style.boxShadow = 'none';
        }
      }
      if (navigator && navigator.permissions) {
        await navigator.permissions.query({ name: 'microphone' }).then(
          (PermissionStatus) => {
            ((PermissionStatus.state === 'denied' || PermissionStatus.state === 'prompt' ) ?
              this.setState({micGranted: false}) : this.setState({micGranted: true})
            )
          }
        );
      }
      window.parent.postMessage("TelbeeChannelLoaded", "*")
    }

    // componentDidUpdate() {
    //     navigator.permissions.query({ name: 'microphone' }).then(
    //         (PermissionStatus) => {
    //             ((PermissionStatus.state === 'denied' || PermissionStatus.state === 'prompt' ) ?
    //                 this.setState({micGranted: false}) : this.setState({micGranted: true}))
    //         })
    // }
    async proceed() {
        await this.setState({processing: true});
        const { onSwitch } = this.props;
        const { micGranted, processing } = this.state;
        if (micGranted){
                onSwitch('recording',{processing: processing });
        }else{
            onSwitch('mic-check')
        }
    }

    render() {
        const { pluginMode, settings, micAllowed } = this.props;
        const { common } = settings;
        const {sourceType, email, fName, processing } = this.state;
        return (
        <>

          <StartContainer className="content" settings={settings}>
              <div className="plugin-header">
            <div
              className="title"
              style={{
                fontSize: common.fontSize || null,
                // fontFamily: common.fontFamily,
                // color: common.fontColor,
              }}
            >
              {sourceType !== 'reply'
                ?
               <div
               style={{
                   fontStyle: 'normal',
                   fontFamily: 'Titillium Web',
                   fontWeight: 'bold',
                   fontSize: '16px',
                   lineHeight: '24px',
                   color:'#27364E',
                   verticalAlign: 'middle',
                   wordBreak:'break-word',
                   whiteSpace: 'pre-wrap',
               }}>
                  {tspan('welcomeTitle', { break: <br/> })}
               </div>
                : (
                  <ContactName>
                    <p>{`Send a vox reply to ${fName}`}</p>
                    <p>{email}</p>
                  </ContactName>
                )}
            </div>
              </div>
            {!micAllowed ? (
                <div className="sub-title"
                     style={{
                         fontStyle: 'normal',
                         fontFamily: 'Titillium Web',
                         fontWeight: 'normal',
                         fontSize: '15px',
                         lineHeight: '23px',
                         color:'#27364E',
                         marginTop:`${pluginMode ? "10px" : "0"}`,
                         wordBreak:'break-word',
                         whiteSpace: 'pre-wrap',
                     }}>
                    {tspan('welcomeSubTitle', { button: <MicImage> <HexagonSmall
                            common={common} icon={faMicrophone}
                            micPermission={true} /> </MicImage>,
                        break:<br/>
                    })}
                </div>
            ) : null}
          </StartContainer>
            <p style={{marginBottom:'0rem'}}>&nbsp;</p>
          {/* {micAllowed ? ( */}
            <SubFooter>{'Press to begin recording'}</SubFooter>
            <PreFooter>
            <Arrow />
          </PreFooter>
          {/* ) : null} */}
          <ColoredFooter  className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
            <SendVox common={common} arrow={false} processing={processing} onClick={() => this.proceed()}
                     icon={solidMic} micPermission={true} title={pluginMode ? pluginRecord : hostedRecord}/>
          </ColoredFooter>
        </>
      );
    }
}
